module.exports = __webpack_public_path__ + "img/quai.34189c40.png";